/**
 * Functions related to fade in on scroll functionality
 *
 * @param selectedElement
 * @param triggerElement
 * @param activeClass
 *
 * @return void
 */

import {onOrAfterLoad} from "./helpers";

export const initializeFadeIn = (
	targetClass = "u-fade-in",
	visibleClass = "u-fade-in--visible"
) => {

	const elements = document.getElementsByClassName(targetClass);

	function triggerFadeIn(element) {
		element.addEventListener("transitionend", function () {
			element.classList.remove(targetClass, visibleClass);
		});

		let delay = parseInt(element.getAttribute('data-fade-in-delay'));
		delay = isNaN(delay) ? 0 : delay;
		setTimeout(function () {
			element.classList.add(visibleClass);
		}, delay)
	}

	const fadeInObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if(entry.intersectionRatio > 0.25) {
				triggerFadeIn(entry.target);
				fadeInObserver.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.25
	});

	for (let element of elements) {
		onOrAfterLoad(() => fadeInObserver.observe(element));
	}
};
